import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/bootstrap.css'
import '../pages/style.css'
import URL from '../service/API_URL'

const initialForm = { name: '', email: '', phone: '', id_area: '' }

const PlacementHome = () => {
  const [data, setData] = useState(initialForm)
  const [areas, setAreas] = useState([])
  const [formError, setFormError] = useState({})
  const [showStartForm, setShowStartForm] = useState(false)
  const [loadingAreas, setLoadingAreas] = useState(true)
  const [selectedTest, setSelectedTest] = useState('free')
  const [showEssentialToken, setShowEssentialToken] = useState(false)
  const [essentialToken, setEssentialToken] = useState('')
  const [essentialTokenError, setEssentialTokenError] = useState('')
  const [integrityNotice] = useState(() => window.localStorage.getItem('essential_integrity_notice') || '')
  const navigate = useNavigate()
  const essentialsEnabled = true
  const essentialAccessToken = '2026TRIAL'

  useEffect(() => {
    window.localStorage.removeItem('essential_integrity_notice')
    URL.urlApplication.get('master/area')
      .then((response) => setAreas(response.data.data || []))
      .catch(() => setFormError((current) => ({ ...current, area: 'Domisili belum dapat dimuat. Coba refresh halaman.' })))
      .finally(() => setLoadingAreas(false))
  }, [])

  const openStartForm = (testType = 'free') => {
    setSelectedTest(testType)
    setShowStartForm(true)
    window.setTimeout(() => {
      document.getElementById('start-free-test')?.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }, 50)
  }

  const requestEssentialAccess = () => {
    setEssentialToken('')
    setEssentialTokenError('')
    setShowEssentialToken(true)
  }

  const unlockEssential = (event) => {
    event.preventDefault()
    if (essentialToken.trim() !== essentialAccessToken) {
      setEssentialTokenError('The access code is incorrect. Check the code and try again.')
      return
    }
    setShowEssentialToken(false)
    openStartForm('essential')
  }

  const handleChange = (event) => {
    const { name, value } = event.target
    setData((current) => ({ ...current, [name]: value }))
    setFormError((current) => ({ ...current, [name]: '' }))
  }

  const validate = () => {
    const errors = {}
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i
    if (!data.name.trim()) errors.name = 'Nama lengkap wajib diisi.'
    if (!data.email.trim()) errors.email = 'Email wajib diisi.'
    else if (!emailPattern.test(data.email)) errors.email = 'Format email belum valid.'
    if (!data.phone) errors.phone = 'Nomor WhatsApp wajib diisi.'
    if (!data.id_area) errors.id_area = 'Pilih domisili kamu.'
    return errors
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    const errors = validate()
    setFormError(errors)
    if (Object.keys(errors).length === 0) {
      const candidate = { ...data, name: data.name.trim(), email: data.email.trim() }
      navigate(selectedTest === 'essential' ? '/essential-placement-test/intro' : '/placement-test', { state: candidate })
    }
  }

  return (
    <main className="landing-page">
      <nav className="landing-nav" aria-label="Main navigation">
        <a className="brand-lockup" href="#top" aria-label="NIEC English Course home">
          <img className="brand-mark" src="/logo512.png" alt="" />
          <span><strong>NIEC</strong><small>English Course</small></span>
        </a>
        <button className="nav-cta" type="button" onClick={() => openStartForm('free')}>Take the free test</button>
      </nav>

      {integrityNotice && <div className="integrity-restart-notice" role="alert"><strong>Test restart required</strong><span>{integrityNotice}</span></div>}

      <section className="hero-section" id="top">
        <div className="hero-copy">
          <span className="eyebrow">Know your level. Own your next move.</span>
          <h1>Your English level, <span>made clear.</span></h1>
          <p className="hero-description">Take an NIEC placement test to understand where you are now and get a clearer direction for what to learn next.</p>
          <div className="hero-actions">
            <button className="primary-cta" type="button" onClick={() => openStartForm('free')}>Start free test</button>
            <a className="secondary-cta" href="#test-options">Explore test options</a>
          </div>
          <div className="hero-proof" aria-label="Free placement test highlights">
            <div><strong>15 min</strong><span>Quick to finish</span></div>
            <div><strong>20</strong><span>Focused questions</span></div>
            <div><strong>Free</strong><span>Instant level snapshot</span></div>
          </div>
        </div>
        <div className="hero-visual" aria-hidden="true">
          <div className="visual-label">YOUR ENGLISH CHECK-IN</div>
          <img src="/assets/img/login-img.png" alt="" />
          <div className="level-card"><small>Your next level</small><strong>starts here.</strong></div>
        </div>
      </section>

      <section className="purpose-section" aria-labelledby="purpose-title">
        <div><span className="section-kicker">Why take a placement test?</span><h2 id="purpose-title">Learn smarter from the very first step.</h2></div>
        <div className="purpose-grid">
          <article><span>01</span><h3>Know your level</h3><p>Get a practical snapshot of the English skills you already have.</p></article>
          <article><span>02</span><h3>Spot your gaps</h3><p>See which core areas need more attention and focused practice.</p></article>
          <article><span>03</span><h3>Choose your path</h3><p>Use your result to start learning at the level that fits you best.</p></article>
        </div>
      </section>

      <section className="test-options-section" id="test-options" aria-labelledby="test-options-title">
        <div className="section-heading"><span className="section-kicker">Pick your test</span><h2 id="test-options-title">One goal, two ways to get there.</h2><p>Start fast with the Free test or choose the complete Essentials assessment.</p></div>
        <div className="test-card-grid">
          <article className="test-option-card featured">
            <div className="card-topline"><span className="status-badge live">Available now</span><span className="test-number">01</span></div>
            <h3>Free Placement Test</h3>
            <p>Short on time? Get an immediate snapshot of your core English skills with our 15-minute express assessment.</p>
            <div className="test-facts"><span><strong>15</strong> minutes</span><span><strong>20</strong> questions</span><span><strong>2</strong> sections</span></div>
            <ul><li>10 Reading questions</li><li>10 Written Expression questions</li><li>Instant feedback on your current level</li></ul>
            <button className="card-cta" type="button" onClick={() => openStartForm('free')}>Start free test</button>
          </article>
          <article className={`test-option-card ${essentialsEnabled ? '' : 'upcoming'}`}>
            <div className="card-topline"><span className={`status-badge ${essentialsEnabled ? 'live' : 'soon'}`}>{essentialsEnabled ? 'Available now' : 'Awaiting final question bank'}</span><span className="test-number">02</span></div>
            <h3>Essentials Placement Test</h3>
            <p>Measure your Listening, Reading, and Writing skills with a structured assessment reviewed by NIEC.</p>
            <div className="test-facts"><span><strong>110</strong> minutes</span><span><strong>60</strong> questions</span><span><strong>3</strong> sections</span></div>
            <ul><li>30 Listening questions</li><li>30 Reading questions</li><li>One 40-minute academic Writing task</li></ul>
            <button className={`card-cta ${essentialsEnabled ? '' : 'disabled'}`} type="button" disabled={!essentialsEnabled} onClick={requestEssentialAccess}>{essentialsEnabled ? 'Start Essentials test' : 'Not available yet'}</button>
          </article>
        </div>
      </section>

      <section className={`quick-start-section ${showStartForm ? 'is-open' : ''}`} id="start-free-test" aria-labelledby="quick-start-title">
        <div className="quick-start-copy"><span className="section-kicker light">Ready when you are</span><h2 id="quick-start-title">Four details, then you’re in.</h2><p>{selectedTest === 'essential' ? 'Your 110-minute Essentials test moves through Listening, Reading, then Writing.' : 'We’ll ask for your school information only when you finish, right before we prepare your result.'}</p><div className="privacy-note">Your details are used to identify your test and deliver your result.</div></div>
        <form className="quick-start-form" onSubmit={handleSubmit} noValidate>
          <div className="field-group"><label htmlFor="name">Full name</label><input id="name" name="name" value={data.name} onChange={handleChange} className={formError.name ? 'has-error' : ''} placeholder="Your full name" autoComplete="name" />{formError.name && <small className="field-error">{formError.name}</small>}</div>
          <div className="field-group"><label htmlFor="email">Email</label><input id="email" name="email" type="email" value={data.email} onChange={handleChange} className={formError.email ? 'has-error' : ''} placeholder="you@email.com" autoComplete="email" />{formError.email && <small className="field-error">{formError.email}</small>}</div>
          <div className="field-group"><label htmlFor="phone">WhatsApp number</label><PhoneInput country="id" value={data.phone} onChange={(phone) => { setData((current) => ({ ...current, phone })); setFormError((current) => ({ ...current, phone: '' })) }} inputProps={{ id: 'phone', name: 'phone', autoComplete: 'tel' }} inputClass={formError.phone ? 'has-error' : ''} containerClass="phone-field" />{formError.phone && <small className="field-error">{formError.phone}</small>}</div>
          <div className="field-group"><label htmlFor="id_area">Domicile</label><select id="id_area" name="id_area" value={data.id_area} onChange={handleChange} className={formError.id_area ? 'has-error' : ''} disabled={loadingAreas}><option value="">{loadingAreas ? 'Loading domicile...' : 'Choose your domicile'}</option>{areas.map((area) => <option key={area.id_area} value={area.id_area}>{area.area}</option>)}</select>{(formError.id_area || formError.area) && <small className="field-error">{formError.id_area || formError.area}</small>}</div>
          <button className="form-submit" type="submit">Register &amp; start test <span aria-hidden="true">→</span></button>
          <p className="form-footnote">{selectedTest === 'essential' ? 'Essentials test · 110 minutes · Listening + Reading + Writing' : 'Free test · 15 minutes · No payment required'}</p>
        </form>
      </section>

      <footer className="landing-footer"><div className="brand-lockup footer-brand"><img className="brand-mark" src="/logo512.png" alt="" /><span><strong>NIEC</strong><small>English Course</small></span></div><p>English for Study Abroad</p></footer>

      {showEssentialToken && <div className="essential-token-backdrop" role="dialog" aria-modal="true" aria-labelledby="essential-token-title">
        <form className="essential-token-dialog" onSubmit={unlockEssential}>
          <div className="essential-token-heading">
            <div><span className="section-kicker">Private access</span><h2 id="essential-token-title">Enter your Essentials access code</h2></div>
            <button type="button" aria-label="Close access code dialog" onClick={() => setShowEssentialToken(false)}>×</button>
          </div>
          <p>This test is currently available only to invited candidates.</p>
          <label htmlFor="essential-access-token">Access code</label>
          <input id="essential-access-token" type="text" value={essentialToken} onChange={(event) => { setEssentialToken(event.target.value); setEssentialTokenError('') }} autoComplete="off" autoFocus className={essentialTokenError ? 'has-error' : ''} placeholder="Enter access code" />
          {essentialTokenError && <small className="essential-token-error" role="alert">{essentialTokenError}</small>}
          <div className="essential-token-actions">
            <button type="button" className="essential-secondary" onClick={() => setShowEssentialToken(false)}>Cancel</button>
            <button type="submit" className="essential-primary">Continue</button>
          </div>
        </form>
      </div>}
    </main>
  )
}

export default PlacementHome
